import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropRoutingModule } from './drop-routing.module';
import { DropDownComponent } from './dropDown.component';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {DropdownModule} from "../../component/ing/dropdown/dropdown";
import {TableModule} from "../../component/ing/table/table";

@NgModule({
  imports: [
    CommonModule,
    DropRoutingModule,
    FormsModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    DropdownModule,
    TableModule
  ],
  declarations: [DropDownComponent]
})
export class DropDownDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/dropDown/dropDownDemo.module.ts